
import { useContext, useState } from 'react';
import ProfileOrderCardDetails from './ProfileOrderCardDetails';
import { AppContext } from '../../../contextApi/ContextApi';

export default function ProfileOrderCard({order}) {
    const { accent_color, secondary_color, primary_color, formatDate, calculateDaysPassed } = useContext(AppContext);
    const [detailsFlag, setDetailsFlag] = useState(false);
    return (
        <div className='profile_orderCard'>
            <div className='profile_orderCard_mainDetails' dir='rtl' onClick={()=>{setDetailsFlag(!detailsFlag)}} style={{backgroundColor:primary_color, color:accent_color, textShadow:`1px 1px 3px ${secondary_color}`}}>
                <div className='profile_orderCard_mainDetails_div' style={{border:`0.5px solid ${accent_color}`}}>
                    <p className='profile_orderCard_mainDetails_header'>מס' הזמנה:</p>
                    <p className='profile_orderCard_mainDetails_content'>{order._id}</p>
                </div>
                <div className='profile_orderCard_mainDetails_div' style={{border:`0.5px solid ${accent_color}`}}>
                    <p className='profile_orderCard_mainDetails_header'>תאריך הזמנה:</p>
                    <p className='profile_orderCard_mainDetails_content'>{formatDate(order.orderTime)} ({calculateDaysPassed(order.orderTime)} ימים)</p>
                </div>
                <div className='profile_orderCard_mainDetails_div' style={{border:`0.5px solid ${accent_color}`}}>
                    <p className='profile_orderCard_mainDetails_header'>סטטוס הזמנה:</p>
                    <p className='profile_orderCard_mainDetails_content' style={{color:order.status==="בטיפול" ? "yellow" : order.status==="בדרכה ליעד" ? "orange" : order.status==="התקבלה" ? "green" : accent_color}}>{order.status}</p>
                </div>
            </div>
            <ProfileOrderCardDetails order={order} detailsFlag={detailsFlag}/>
        </div>
    )
}
